import { useNavigate } from "react-router-dom";
import { toast } from "sonner";

export const handleAuthError = async (response: Response, refreshToken: () => Promise<boolean>) => {
  if (response.status === 401 || response.status === 403) {
    const refreshSuccess = await refreshToken();
    if (!refreshSuccess) {
      // If refresh token fails, redirect to login
      window.location.href = '/login';
      return true;
    }
    return true;
  }
  return false;
};

export const handleApiError = async (error: any, refreshToken: () => Promise<boolean>) => {
  if (error?.response?.status === 401 || error?.response?.status === 403) {
    const refreshSuccess = await refreshToken();
    if (!refreshSuccess) {
      // If refresh token fails, redirect to login
      window.location.href = '/login';
      return true;
    }
    return true;
  }
  return false;
}; 